<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="activityTypeMain">
          <v-card id="activityTypeCard">
            <v-card-title
              id="tableTitle"
              class="primary--text"
              style="font-size: 1.5em; padding: 20px"
              >{{ $t('nav.activityType') }}</v-card-title
            >
            <v-data-table
              id="activityTypeTable"
              :headers="headers"
              :items="items"
              :items-per-page="-1"  
              class="elevation-0"
            >
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: right">{{ props.item.activityID }}</td>
                  <td style="text-align: left">{{ props.item.description }}</td>

                  <td style="text-align: center">
                    <v-btn
                      id="btnDel"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      :disabled="props.item.isDeleted === true"
                      @click="deleteItemConfirm(props.item)"
                    >
                      <v-icon small color="primary">
                        mdi-delete
                      </v-icon> </v-btn
                    >&nbsp;
                    <v-btn
                      id="btnEdit"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      @click="editItem(props.item)"
                    >
                      <v-icon small color="primary"> mdi-pencil </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="showDialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form @submit.prevent="submit" ref="form">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.activityID"
                          :rules="[
                            () => !!editedItem.activityID || requiredMessage
                          ]"
                          required
                          :readonly="editedIndex > -1"
                        >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('nav.activityTypeId') }}
                          </template></v-text-field
                        >
                      </v-col>

                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.description"
                          :rules="[
                            () => !!editedItem.description || requiredMessage
                          ]"
                          required
                        >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('column.description') }}
                          </template></v-text-field
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">{{
                    $t('common.cancel')
                  }}</v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="save"
                    :disabled="!formIsValid"
                    >{{ $t('common.save') }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card-actions id="pCardAct">
              <v-fab-transition>
                <v-btn
                  id="btnAddactivityType"
                  color="primary"
                  dark
                  small
                  left
                  fab
                  @click="createItem()"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-card-actions>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      showDialog: false,
      selProjectId: 0,
      selVesselId: 0,
      requiredMessage: this.$t('common.required'),
      headers: [
        {
          text: this.$t('nav.activityTypeId'),
          align: 'right',
          sortable: true,
          value: 'activityID',
          width: '15%'
        },
        {
          text: this.$t('column.description'),
          align: 'left',
          value: 'description'
        },
        {
          text: this.$t('column.actions'),
          align: 'center',
          value: 'opactions',
          sortable: false,
          width: '20%'
        }
      ],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {}
    }
  },
  computed: {
    ...mapGetters(['m_actType/getNextSeqCode', 'm_actType/getActivityTypes']),
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('common.new') + ' ' + this.$t('nav.activityType')
        : this.$t('common.edit') + ' ' + this.$t('nav.activityType')
    },
    items() {
      return this['m_actType/getActivityTypes']
    },

    formIsValid() {
      return this.editedItem.activityID && this.editedItem.description
    }
  },
  watch: {
    showDialog(val) {
      val || this.close()
    }
  },

  created() {
    this['m_actType/fetchNextMaxCode']()
    this['m_actType/fetchActivityTypes']()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader()
    })
  },
  methods: {
    ...mapActions([
      'm_actType/createActivityType',
      'm_actType/fetchActivityTypes',
      'm_actType/fetchNextMaxCode',
      'm_actType/updateActivityType',
      'm_actType/deleteActivityType',
    ]),
    ...mapMutations(['mHideLongLoader']),

    resetEntity(item) {
      this.editedIndex = item ? this.items.indexOf(item) : -1
      this.editedItem = Object.assign({}, item || this.defaultItem)
    },

    editItem(item) {
      this.resetEntity(item)
      this.showDialog = true
    },

    createItem() {
      this.resetEntity()
      this.editedItem.activityID = this['m_actType/getNextSeqCode']
      this.showDialog = true
    },

    deleteItemConfirm(item) {
      this.resetEntity(item)
      var msg = this.editedItem.isDeleted ? 'warming.unlock' : 'warming.lock'

      this.$confirm(this.$t(msg) + this.$t('nav.activityType') + '?', {
        buttonTrueText: this.$t('common.delete'),
        buttonFalseText: this.$t('common.cancel'),
        color: 'warning',
        icon: 'warning',
        title: this.$t('common.warning'),
        width: 350,
        property: '$confirm'
      }).then(
        (res) => res && this['m_actType/deleteActivityType'](this.editedItem)
      )
    },

    close() {
      this.$refs.form.resetValidation()
      this.showDialog = false
    },

    save() {
      if (~this.editedIndex) {
        this['m_actType/updateActivityType'](this.editedItem)
      }

      if (!~this.editedIndex) {
        this['m_actType/createActivityType'](this.editedItem)
      }

      this.close()
    }
  }
}
</script>

<style>
#activityTypesTable {
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto;
}
#activityTypesTable header {
  font-weight: bold;
}
#activityTypesCard {
  width: auto;
}
</style>